import { Component } from '@angular/core'

@Component({
  selector: 'app-bundle-definition',
  templateUrl: './bundle-definition.component.html',
  styleUrls: ['./bundle-definition.component.css'],
  standalone: false
})
export class BundleDefinitionComponent {}
